import { useEffect } from "react";
import { ContentSection, Main } from "@vwfs-bronson/bronson-react";
import { Outlet, useLocation } from "react-router-dom";
import Footer from "../components/ui/Footer";
import Header from "../components/ui/Header";
import Notifications from "../components/ui/Notifications";
import Loading from "../components/ui/Loading";
import { useAuth } from "../hooks/useAuth";

export const Initializer = () => {
  let location = useLocation();
  const { loading, login } = useAuth();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  return (
    <div className="o-root">
      {login && <Notifications />}
      <Header />
      <Main className="u-ph" role="main">
        <ContentSection>
          <Outlet />
        </ContentSection>
      </Main>
      {loading && <Loading></Loading>}
      <Footer />
    </div>
  );
};
